import Vue from 'vue'
import VueRouter from 'vue-router'
import TabelasCopariticipacao from '../views/TabelaCoparticipacao.vue'
import PesquisaTabelaCoparticipacao from '../views/PesquisaTabelaCoparticipacao.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PesquisaTabelaCoparticipacao',
    component: PesquisaTabelaCoparticipacao,
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/tabelas',
    name: 'Tabelas',
    component: TabelasCopariticipacao,
    props: true
  },
  {
    path: '/:tipopessoa',
    name: 'Home',
    component: PesquisaTabelaCoparticipacao,
    props: (route) => ({ isShowButtonUFSC: route.params.tipopessoa === 'pj' })
  }
]

const router = new VueRouter({
  mode: 'history',
   base: process.env.VUE_APP_PUBLIC_PATH || '/',
  routes
})

export default router
